import React from "react";
import "./herosection.css";

const HeroSection = ({data, setBlank}) => {
    
    const gotobyid = (id)=> {
        setBlank(true);
        setTimeout(() => {            
            const jobopening = document.getElementById(id);
            window.scrollTo(0, jobopening.offsetTop);
            setBlank(false);
        }, 100);
    }

  return (
    <section
      className="hero-section"
      style={{
        "--hero-bg-image": `url("${data.backgroundImage}")`,
        "--hero-overlay-opacity": data.overlay.opacity,
      }}
    >
      {/* Background Overlay */}
      {data.overlay.enabled && (
        <div className="hero__overlay"></div>
      )}

      {/* Content */}
      <div className="hero__container">
        <div className="hero__content">
          <div className="hero__eyebrow">
          {/* Eyebrow */}
          {data.content.eyebrow && (
              <h6>
              {data.content.eyebrow}</h6>
          )}

          {/* Heading */}
          <h1 className="hero__title">
            {data.content.heading.map((item, index) => (
              <span
                key={index}
                className={
                  item.highlight
                    ? "hero__highlight"
                    : ""
                }
              >
                {item.text}
              </span>
            ))}
          </h1>

          {/* Description */}
          {data.content.description && (
            <p className="hero__description">
              {data.content.description}
            </p>
          )}
          </div>

          {/* Buttons */}
          {data.buttons?.length > 0 && (
            <div className="hero__buttons">

              {data.buttons.map((button) => (
                <a
                  key={button.id}
                  href={button.href}
                  onclick={() => gotobyid('contactform')}
                  className={`hero__button hero__button--${button.style}`}
                >
                  {button.label}
                </a>
              ))}

            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default HeroSection;